import React from "react";
import {
  expenseCategories,
  expensesByMonth,
  expensesByMonthAndCategory,
  formatMoney,
  total,
} from "../expense_utils";

export default ({ expenses }) => {
  const byMonthAndCategory = expensesByMonthAndCategory(expenses);
  const byMonth = expensesByMonth(expenses);

  const months = Object.keys(byMonthAndCategory);
  const categories = expenseCategories(expenses);
  // formatMoney(total(expenses))
  // console.log({ categories });

  return (
    <table className="w-full text-right">
      <thead className="bg-blue-500 text-blue-100">
        <tr className="">
          <th className="p-2">Category</th>
          {months.map(month => (
            <th className="p-2 " key={month}>
              {month}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {categories.map((category, i) => (
          <tr
            key={category || "null"}
            className={i % 2 == 0 ? "bg-blue-100" : ""}
          >
            <th className="bg-blue-600 text-blue-100 p-2">
              {category || "Other"}
            </th>
            {months.map(month => (
              <td key={`${category}-${month}`} className="p-2">
                {formatMoney(total(byMonthAndCategory[month][category]))}
              </td>
            ))}
          </tr>
        ))}
        <tr className="bg-blue-500 text-blue-100">
          <th className="p-2">Total</th>
          {months.map(month => (
            <th key={`total-${month}`} className="p-2">
              {formatMoney(total(byMonth[month]))}
            </th>
          ))}
        </tr>
      </tbody>
    </table>
  );
};
